import React from 'react';

import { withStyles, makeStyles } from '@material-ui/core/styles';

import {isNull,isUndefined} from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import IntlMessages from 'util/IntlMessages';

const genStyles = () => {
  return makeStyles({
    
    colorProg: {
      backgroundColor:'#E6E6E6'
    },
    rootProg: {
      height: 10,
      borderRadius: 5,
    },
    
    prog90: {
      // backgroundColor: '#66bb6a',
      background: 'rgb(12,150,156);',
      borderRadius: '6px',
      background: 'linear-gradient(48deg, rgba(12,150,156,1) 0%, rgba(125,106,154,1) 100%);'
    },
   
  })
}


const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 7,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:  '#fff',
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#3ca9af',
  },
}))(LinearProgress);



const TopListaProdukterBar = ({item}) => {

  const styles = genStyles()
  const classes = styles()

  return (
    <div>
    <p style={{marginBottom: -3, fontSize:16}}>{isNull(item.label) ? <IntlMessages id="Label.Product"/> : item.label}</p>
    <div className="w-100 mb-1 d-flex align-items-center">
      <div className="w-100 pr-2">
        <LinearProgress 
          variant="determinate" 
          value={item.percent}
          classes={{
            root:classes.rootProg,
            colorPrimary: classes.colorProg,
            bar: classes.prog90
          }}
        />
        {/* <BorderLinearProgress  variant="determinate" value={item.percent}/> */}
      </div>
      <span style={{fontSize:16}}>
        {item.value}st
      </span>
    </div>
  </div>
  )
}
  



const TopplistaProdukterBars = ({ data, title,intervalFunction }) => {

  console.log(data, 'data')

    React.useEffect(() => {
        if(!isUndefined(intervalFunction)) {
            intervalFunction()
            let id = setInterval(() => {
                intervalFunction();
            }, 30000);
            return () => clearInterval(id);
        }
    }, []);

  return (
    <div className="h-100 d-flex flex-column align-items-center justify-content-between postition-relative">
        <div className="w-100">
        <h3 className="mb-0" style={{padding: '8px 16px'}}>{title}</h3>
        {/* <p style={{color: '#0c969c', padding: '8px 16px'}}>{title}</p> */}
        <Divider/>
        </div>
        <div className="w-100" style={{padding: '14px 16px'}}>
      {
        data.map((d,index) => {
          return <TopListaProdukterBar item={d} key={index}/>
        })
      }
      </div>
    </div>
  );
};

export default TopplistaProdukterBars;
